import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { Link } from "react-router-dom";
import "./ForgotPassword.css";
import logo from '../assets/logo.svg';

const schema = yup.object({
    email: yup.string().email("E-mail nemá správny formát").required("Zadajte e-mail"),
}).required();

// Automatická obnova hesla zatiaľ nie je — vybavujeme ju ručne cez podporu.
// (TODO: reset endpoint + token; vyžaduje rozšírenie DB, zatiaľ nezasahujeme.)
const ForgotPassword = () => {
    const [submittedEmail, setSubmittedEmail] = useState(null);
    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });

    const handlePasswordReset = (data) => {
        setSubmittedEmail(data.email);
    };

    return (
        <div className="forgot-password-container">
            <div className="forgot-password-card">
                <img src={logo} alt="Effzone" className="logo-image" />
                <h2 className="title">Zabudnuté heslo?</h2>

                {submittedEmail ? (
                    <>
                        <p className="instructions">
                            Heslo vám obnovíme ručne — napíšte nám z adresy{' '}
                            <strong>{submittedEmail}</strong> a do pár hodín sa ozveme.
                        </p>
                        <a
                            className="btn btn-primary btn-block"
                            href={`mailto:hi@rieshim.app?subject=Obnova hesla Effzone&body=Prosím o obnovu hesla pre účet ${encodeURIComponent(submittedEmail)}.`}
                        >
                            Napísať podpore
                        </a>
                    </>
                ) : (
                    <>
                        <p className="instructions">
                            Zadajte e-mail, s ktorým ste sa registrovali — poradíme vám s obnovou.
                        </p>
                        <form onSubmit={handleSubmit(handlePasswordReset)}>
                            <div className="form-group">
                                <input
                                    type="email"
                                    className="form-control"
                                    {...register("email")}
                                    placeholder="vas@email.sk"
                                />
                                {errors.email && <p className="error-message">{errors.email?.message}</p>}
                            </div>
                            <div className="form-group">
                                <button type="submit" className="btn btn-primary btn-block">
                                    Pokračovať
                                </button>
                            </div>
                        </form>
                    </>
                )}

                <Link to="/login" className="back-to-login">
                    &larr; Späť na prihlásenie
                </Link>
            </div>
        </div>
    );
};

export default ForgotPassword;
